import ItineraryItem from './ItineraryItem'

export const DINNER_TIME_VALUES = [
  { label: 'N/A', value: '' },
  { label: '18:00', value: '18:00' }, { label: '18:15', value: '18:15' },
  { label: '18:30', value: '18:30' }, { label: '18:45', value: '18:45' },
  { label: '19:00', value: '19:00' }, { label: '19:15', value: '19:15' },
  { label: '19:30', value: '19:30' }, { label: '19:45', value: '19:45' },
  { label: '20:00', value: '20:00' }, { label: '20:15', value: '20:15' },
  { label: '20:30', value: '20:30' }, { label: '20:45', value: '20:45' },
  { label: '21:00', value: '21:00' }, { label: '21:15', value: '21:15' },
  { label: '21:30', value: '21:30' }, { label: '21:45', value: '21:45' },
  { label: '22:00', value: '22:00' }
]

export default class HotelItineraryItem extends ItineraryItem {
  constructor (data, container, isYgtBooking) {
    super(data, container, isYgtBooking)
    this.branded_header = this.brandedHeader()
    this.attributesForUpdates = ['dinner_time']
    this.original_dinner_time = this.originalData.dinner_time
  }

  brandedHeader () {
    if (this.isYgtBooking !== true) {
      return 'Hotel stay'
    } else {
      return this.hotel_name
    }
  }

  validateDinnerTime () {
    if (this.dinner_time === null ||
      DINNER_TIME_VALUES.map((dtv) => dtv.value).includes(this.dinner_time)
    ) {
      return {}
    }
    return { dinner_time: ['invalid'] }
  }

  validate () {
    return {
      ...super.validate(),
      ...this.validateDinnerTime()
    }
  }
}
